










































import { Component } from "vue-property-decorator";
import QuizPage from "../../components/QuizPage";
import DebugData from "../../components/DebugData.vue";
@Component({
  components: {
    DebugData
  }
})
export default class Children extends QuizPage {
  private created() {
    this.init("children", "/results");
    // Check to see if we landed on this question by coming back
    // from the results page. If so we no longer have state and
    // therefore have to start the quiz over again.
    if (this.$store.state.question == 1) {
      this.$router.replace("/");
    }
  }

  private getResults() {
    window.location.href = this.hpurl;
  }

  private get hpurl(): string {
    return (
      "https://hyperproof.io/quiz-final-page-2/?fw=" +
      Array.from(this.$store.getters.mergedFrameworks)
        .sort()
        .join(",")
    );
  }
}
